/**
 * Janus `filter_groups` / `permissions.group_name` values for staff and role permission catalog calls.
 * Keep in sync with {@code com.apds.usermgmt.constants.StaffPermissionFilterGroups} (admin-portal-api).
 */

/** Single group names — add a constant here when a new catalog slice exists in Janus. */
export const StaffPermissionFilterGroup = {
  /** User-controllable Feeds toggles (CC-14117 / CC-14319). */
  FEEDS: 'feeds',
  /** User-controllable Reentry Planning toggles (CC-15199). */
  REENTRY_PLANNING: 'reentry_planning',
};

/**
 * Default `filter_groups` allow-list for Janus role/staff permission endpoints when loading the
 * user-configurable catalog (`is_user_configurable=true`), e.g. create-staff step and profile Permissions tab.
 * Call sites request a subset via `resolveEnabledPermissionFilterGroups` so LFA-gated groups are
 * omitted when their gate is currently false. Append {@link StaffPermissionFilterGroup} entries
 * when additional groups should appear in those UIs.
 */
export const staffUserConfigurablePermissionFilterGroups = Object.freeze([
  StaffPermissionFilterGroup.FEEDS,
  StaffPermissionFilterGroup.REENTRY_PLANNING,
]);

/**
 * Same set as the staff-list enabled-permissions batch summary on the gateway (see backend
 * {@code StaffPermissionFilterGroups#ENABLED_PERMISSIONS_SUMMARY_GROUPS}). Extend together with that list.
 */
export const staffListEnabledPermissionsSummaryFilterGroups = Object.freeze([
  StaffPermissionFilterGroup.FEEDS,
  StaffPermissionFilterGroup.REENTRY_PLANNING,
]);
